<template>
    <div v-if="acceptData && acceptData.length > 0">
        <!-- 列表 -->
        <List v-if="isList" :itemData="acceptData" />
        <!-- 单个 -->
        <Single v-else :itemData="acceptData" />
    </div>
</template>

<script>
import List from './list.vue'
import Single from './single.vue'
export default {
    props: ['acceptData'],
    name: 'ExpertInfo',
    components: {
        List,
        Single
    },
    computed: {
        isList() {
            return this.acceptData && this.acceptData.length > 1
        }
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/expertInfo/index.vue